import { GridColDef } from '@mui/x-data-grid';

export const COLUMNS: GridColDef[] = [
  {
    field: 'country',
    headerName: 'Country',
    width: 150,
    renderCell: (params) => params.row.country?.displayName || 'N/A',
    filterable: false,
    sortable: false,
  },
  {
    field: 'region',
    headerName: 'Region',
    width: 150,
    renderCell: (params) => params.row.country?.region?.displayName || 'N/A',
    filterable: false,
    sortable: false,
  },
  {
    field: 'buyerCompanyName',
    headerName: 'Buyer Company',
    width: 150,
    flex: 1,
    renderCell: (params) => params.row.maCompanyTransaction?.buyerCompanyName || 'N/A',
    filterable: false,
    sortable: false,
  },
  {
    field: 'sellerCompanyName',
    headerName: 'Seller Company',
    width: 150,
    flex: 1,
    renderCell: (params) => params.row.maCompanyTransaction?.sellerCompanyName || 'N/A',
    filterable: false,
    sortable: false,
  },
  {
    field: 'assetName',
    flex: 1,
    headerName: 'Asset Name',
    width: 150,
    filterable: false,
    sortable: false,
  },
  {
    field: 'shoreStatus',
    headerName: 'Shore Status',
    width: 150,
    filterable: false,
    sortable: false,
  },
  {
    field: 'workingInterest',
    headerName: 'Working Interest',
    width: 150,
    filterable: false,
    sortable: false,
  },
];
